import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import './nprogress-override.css';

NProgress.configure({
    showSpinner: false,
    minimum: 0.1,
    trickleSpeed: 200,
});

let activeRequests = 0;
let startTimer: NodeJS.Timeout | null = null;

// Delay show to avoid flicker on fast requests
const DELAY_MS = 250;

export const startProgress = () => {
    activeRequests += 1;
    if (activeRequests === 1 && !startTimer) {
        startTimer = setTimeout(() => {
            NProgress.start();
            startTimer = null;
        }, DELAY_MS);
    }
};

export const doneProgress = () => {
    activeRequests = Math.max(0, activeRequests - 1);
    if (activeRequests === 0) {
        if (startTimer) {
            clearTimeout(startTimer);
            startTimer = null;
        } else {
            NProgress.done();
        }
    }
};

export const resetProgress = () => {
    activeRequests = 0;
    if (startTimer) {
        clearTimeout(startTimer);
        startTimer = null;
    }
    NProgress.done();
};

export default NProgress;